import Alert from 'components/Dashboard/cards/Alert'
import { MedicalHistory } from 'components/UI/svgIcons'
import { observer } from 'mobx-react-lite'
import User from 'singletons/User'

type TransmissionError = {
  patientId?: number
  prescriptionId?: number
  dateWritten?: string
  errorDateTimeStamp?: string
  errorDetails?: string
}

type TransmissionErrorProps = {
  transmissionError: TransmissionError
}

const TransmissionError = ({ transmissionError }: TransmissionErrorProps) => {
  const { provider } = User
  return (
    <Alert
      type={'info'}
      title={'Transmission error'}
      Icon={MedicalHistory}
      buttonText={'Dismiss'}
      onClick={() => provider.cancelTransmissionError({ transmissionError })}
    >
      {transmissionError?.errorDetails}
    </Alert>
  )
}

export default observer(TransmissionError)
